import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProfileRepository from "../../../repository/ProfileRepository";
import { __remove, __set } from "../../axios_indicator";

export const getProfileAccountInformation = createAsyncThunk('profile_getProfileAccountInformation', async () => {
    __set('PROFILE_API_CALL');
    return await new ProfileRepository().getProfileAccountInformation()
});

const initialState = {
    accountInformation: {}
};
const slice = createSlice({
    name: "Profile",
    initialState: initialState,
    reducers: {
    },
    extraReducers: {
        [getProfileAccountInformation.fulfilled]: (state, { payload }) => {
            state.accountInformation = payload.data.accountInformation
            __remove('PROFILE_API_CALL');
            return state;
        },
        [getProfileAccountInformation.rejected]: (state, { payload }) => {
            __remove('PROFILE_API_CALL');
        }
    },
});

export let { } = slice.actions;

export default slice.reducer;
